/* Notre histoire : scrub (--p), reveals one-shot, compteurs.
   Sans JS ou en prefers-reduced-motion : tout est visible, la page
   reste complète et lisible (états sûrs dans le CSS de la section). */
(function () {
  'use strict';
  var REDUIT = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals one-shot ---------- */
  var revels = document.querySelectorAll('[data-reveal]');
  if (!REDUIT && 'IntersectionObserver' in window) {
    var ioReveal = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            ioReveal.unobserve(e.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );
    revels.forEach(function (el) {
      ioReveal.observe(el);
    });
  } else {
    revels.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ---------- scrub : --p (0 à 1) sur les sections [data-scrub] ----------
     mode "pin"  : progression du scroll à travers une section épinglée
                   (sticky) : 0 quand elle arrive, 1 quand elle se décolle.
     mode "view" : progression de la traversée du viewport (ligne de
                   timeline). Les calculs ne tournent que pour les
                   sections proches de l'écran (IO d'activation). */
  var scrubs = [];
  document.querySelectorAll('[data-scrub]').forEach(function (el) {
    scrubs.push({ el: el, mode: el.getAttribute('data-scrub'), actif: false });
  });
  if (!REDUIT && scrubs.length) {
    var ioScrub = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          for (var i = 0; i < scrubs.length; i++)
            if (scrubs[i].el === e.target) scrubs[i].actif = e.isIntersecting;
        });
        peindre();
      },
      { rootMargin: '60% 0px 60% 0px' }
    );
    scrubs.forEach(function (s) {
      ioScrub.observe(s.el);
    });

    var enCours = false;
    function peindre() {
      if (enCours) return;
      enCours = true;
      requestAnimationFrame(function () {
        var vh = innerHeight;
        scrubs.forEach(function (s) {
          if (!s.actif) return;
          var r = s.el.getBoundingClientRect(),
            p;
          if (s.mode === 'pin') p = -r.top / Math.max(1, r.height - vh);
          else p = (vh * 0.82 - r.top) / Math.max(1, r.height);
          p = Math.min(1, Math.max(0, p));
          s.el.style.setProperty('--p', p.toFixed(4));
        });
        enCours = false;
      });
    }
    addEventListener('scroll', peindre, { passive: true });
    addEventListener('resize', peindre, { passive: true });
    peindre();
  }

  /* ---------- compteurs ---------- */
  var fmt = new Intl.NumberFormat('fr-FR');
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }
  function compter(el) {
    var cible = parseInt(el.getAttribute('data-count'), 10);
    /* départ optionnel (ex. 200 000 -> 230 000) : même nombre de chiffres
       du début à la fin, le compteur ne saute pas de « 0 » à six chiffres */
    var depart = parseInt(el.getAttribute('data-depart'), 10) || 0;
    if (depart >= cible) depart = 0;
    var duree = cible - depart > 100 ? 2000 : 1400;
    var t0 = performance.now();
    (function tick(now) {
      var p = Math.min(1, (now - t0) / duree);
      el.textContent = fmt.format(Math.round(depart + easeOutExpo(p) * (cible - depart)));
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }
  var compteurs = document.querySelectorAll('[data-count]');
  if (!REDUIT && 'IntersectionObserver' in window) {
    var ioCompte = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            compter(e.target);
            ioCompte.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    compteurs.forEach(function (el) {
      ioCompte.observe(el);
    });
  }
  /* sans IO ou en mouvement réduit : les valeurs finales sont déjà
     dans le HTML, rien à faire */
})();
